
export const customers = {
  title: "Ügyfelek",
  table: {
    name: "Név",
    email: "Email",
    totalSpent: "Összes költés",
    lastPurchase: "Utolsó vásárlás",
    purchaseCount: "Vásárlások száma",
    status: "Állapot",
    actions: "Műveletek"
  },
  purchases: {
    title: "Vásárlási előzmények",
    all: "Összes",
    active: "Aktív",
    completed: "Teljesített",
    noPurchases: "Nem található vásárlás",
    noActivePurchases: "Nincsenek aktív vásárlások",
    noCompletedPurchases: "Nincsenek teljesített vásárlások",
    details: "Részletek",
    downloadInvoice: "Számla letöltése",
    viewContent: "Tartalom megtekintése",
    invoice: "Számla",
    date: "Dátum",
    amount: "Összeg",
    type: "Típus",
    status: "Állapot",
    creator: "Alkotó",
    digitalContent: "Digitális tartalom",
    consultation: "Konzultáció",
    videoRequest: "Videó kérés",
    package: "Csomag",
    statusActive: "Aktív",
    statusCompleted: "Teljesítve",
    purchaseDetails: "Vásárlás részletei",
    purchaseId: "Vásárlás azonosító",
    paymentMethod: "Fizetési mód",
    invoiceId: "Számla szám",
    time: "Időpont",
    detailedData: "Részletes adatok",
    item: "Tétel",
    quantity: "Mennyiség",
    total: "Összesen",
    creatorDetails: "Tartalom készítő",
    itemDetails: "Tétel részletei",
    downloadingInvoice: "Számla letöltése folyamatban...",
    viewAppointment: "Időpont megtekintése",
    downloadContent: "Tartalom letöltése"
  }
};
